<div *ngIf="loaderService.isLoading | async" id="load" class="loader"></div> 